module.exports = __webpack_public_path__ + "static/media/icon-bell.c947e03f.svg";